import { Result } from "antd";

export const ContateOSuporte: React.FC<{codigo?: string}> = (props) => {
    return (
        <Result
            status={"error"}
            title="Erro"
            subTitle={
                <>
                    Ocorreu uma falha inesperada. Consulte o suporte. <br />
                    {props.codigo && "Código: " + props.codigo}
                </>
            }
        />
    );
}

export default ContateOSuporte;